__turbopack_context__.v({
  "hint": "add-to-cart-module-scss-module__t42Y9q__hint",
  "link": "add-to-cart-module-scss-module__t42Y9q__link",
  "root": "add-to-cart-module-scss-module__t42Y9q__root",
});
